import clsx from 'clsx';
import React from 'react';

import Byline from '@components/Byline';
import ArticleHeader from '@components/FeedItems/ArticleHeader';
import LazyImgixImage from '@components/LazyImgixImage';
import { useAppContext } from '@contexts/AppContext';
import { Article } from '@interfaces/homepage';
import { article_path } from '@routes';
import { getArticleImgSrc } from '@utils/images';

interface ArticlesGridProps {
  articles: Article[];
  className?: string;
  imageTagClass?: string;
}

const ArticlesGrid = ({ articles, className, imageTagClass }: ArticlesGridProps) => {
  const { env } = useAppContext();
  return (
    <div
      className={clsx(
        'grid max-w-[500px] grid-cols-1 gap-48 px-24 sm:grid-cols-2 sm:px-0 md:max-w-full md:grid-cols-4',
        className
      )}
    >
      {articles.map(({ id, title, frontCoverPhoto, picture, slug, authors }) => (
        <article
          key={title}
          className={clsx(
            'flex w-full flex-shrink-0 flex-wrap gap-16 px-40 sm:flex-col sm:flex-nowrap  sm:gap-24 sm:px-0 md:max-w-full md:gap-16'
          )}
        >
          <a href={article_path(slug)} className="flex w-full">
            <LazyImgixImage
              className={clsx(
                'flex w-full object-cover leading-[0] md:max-w-[225px]',
                {
                  'aspect-[16/9]': !frontCoverPhoto,
                  'aspect-[3/4]': frontCoverPhoto,
                },
                imageTagClass
              )}
              sizes="309px"
              alt={title}
              src={getArticleImgSrc(id, frontCoverPhoto ?? picture, env)}
            />
          </a>
          <div className="flex  flex-col">
            <ArticleHeader className="text-headline-xxs" title={title} slug={slug} />

            <Byline authors={authors} className="!text-grayscale-gray" />
          </div>
        </article>
      ))}
    </div>
  );
};

export default ArticlesGrid;
